import React, { useState, useEffect, useRef } from 'react';
import { Button, FormControlLabel, TextField } from "@material-ui/core";
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import config from '../../config/config';
import Radio from '@material-ui/core/Radio';
import { makeStyles } from '@material-ui/core/styles';
import RadioGroup from '@material-ui/core/RadioGroup';
import { useGAEventsTracker } from '../../../util/gtag';
import ReCAPTCHA from 'react-google-recaptcha';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modalpopup from '../../pages/Modalpopup/Modalpopup';
import moment from 'moment';
import CaptchaCode from 'react-captcha-code';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > * + *': {
            marginLeft: theme.spacing(2),
        },
    },
}));

export default function HowDidYouHearAbout(props) {
    const GAEventTracker = useGAEventsTracker(window.location.pathname === "/" ? "/Questionnaire" : window.location.pathname + "/Questionnaire");
    const [submitResponse, setSubmitResponse] = useState(null);
    const [submitValue, setSubmitValue] = useState(false)
    const [detail, setDetail] = React.useState('');
    const [openFailure, setOpenFailure] = useState(false);
    const [displayTextBox, setDisplayTextBox] = useState([])
    const [captchaFreshValue, setCaptchaFreshValue] = useState('');
    const [captchaEnteredValue, setCaptchaEnteredValue] = useState(null)
    const [resetInputValidation, setResetInputValidation] = useState(false)
    const captchaRef = useRef(null);

    useEffect(()=>{
    if(props?.partner?.url_path === "c2"){
        const h4Tags = document.querySelectorAll('h4');
        const h6Tags = document.querySelectorAll('h6');
        const spanTags = document.querySelectorAll('span');
        const a = document.querySelectorAll('a');
        const pTags = document.querySelectorAll('p');
        const divTags = document.querySelectorAll('div');
          h4Tags.forEach(h4 => {
            h4.classList.add('ftpolar-semibold');
          });
          h6Tags.forEach(h6 => {
            h6.classList.add('ftpolar-semibold');
          });
          spanTags.forEach(span => {
            span.classList.add('ftpolar-light');
          });
          a.forEach(a => {
            a.classList.add('ftpolar-light');
          });
          pTags.forEach(p => {
            p.classList.add('ftpolar-light');
          });
          divTags.forEach(div => {
            div.classList.add('ftpolar-light');
          });
    }
    },[props.pageNumber,props.submitResponse])

    const classes = useStyles();
    const onChange = (e) => {
        let captcha = document.getElementById("recaptcha")
        if (e) {
            props.setErrorMessage(false)
            setSubmitValue(true)
        } else {
            props.setErrorMessage(true)
            setSubmitValue(false)
            props.setCaptchaVisible(true)
        }
    }
    const handleBefour = () => {
        if (props.errorMessage !== false) {
            props.setErrorMessage(true)
        }
        props.ValidateFinalError()
    }
    const handlePopUpClose1 = () => {
        setOpenFailure(!openFailure)
        window.location.reload()
    }
    const handleCloseFailure = () => {
        window.location.reload()
    }
    let authorise = process.env.REACT_APP_API_KEY

    //  Google Submit Lead Form Conversion Tracker Code
    function gtag_report_conversion(url) {
        var callback = function () {
            return
        };
        window.gtag('event', 'conversion', {
            'send_to': 'AW-10975161999/9LAQCLHq8OADEI_drvEo',
            'event_callback': callback
        });
        return false;
    }

    const handleHomeSection=()=>{
        props.handlePageChange(2)
        // props.handleNext("property")
    }

    const handleSubmit = () => {
        var postData = {
            property_address: {
                street_address: props.values.property_address.street_address ? props.values.property_address.street_address.split(",")[0] : props.values.property_address_get.street_address.split(",")[0],
                city: props.values.property_address.city ? props.values.property_address.city : props.values.property_address_get.city,
                state: props.values.property_address.state ? props.values.property_address.state : props.values.property_address_get.state,
                zip_code: props.values.property_address.zip_code ? props.values.property_address.zip_code : props.values.property_address_get.zip_code,
                county: props.values.property_address.county ? props.values.property_address.county : props.values.property_address_get.county,
                state_code: props.values.property_address.state_code ? props.values.property_address.state_code : props.values.property_address_get.state_code,
            },
            property_type: props.values.property_type_id ? Number(props.values.property_type_id) : null,
            is_owner: props.values.is_owner === "yes" ? true : false,
            non_owner_comments: props.values.non_owner_comments === '' ? '' : props.values.non_owner_comments,
            is_primary_residence: props.values.is_primary_residence === "yes" ? true : false,
            non_resident_comments: props.values.non_resident_comments === '' ? '' : props.values.non_resident_comments,
            customer_info: {
                customer_first_name: props.values.customer_info.customer_first_name,
                customer_last_name: props.values.customer_info.customer_last_name,
                customer_email: props.values.customer_info.customer_email,
                customer_phone_no: props.values.customer_info.customer_phone_no,
            },
            purchase_and_finance_history: {
                purchase_date: props.values.purchased_date === null ? null : moment(props.values.purchased_date).format('YYYY-MM-DD'),
                purchase_price: props.values.price_paid === null ? null : parseFloat(props.values.price_paid.replace(/[$,]/g, '')),
                total_mortgage_amount: props.values.total_mortgage === null ? null : parseFloat(props.values.total_mortgage.replace(/[$,]/g, '')),
                is_mortgage_amount: props.values.estimate === "yes" ? true : false,
                monthly_mortgage_amount: props.values.total_mortgage_amount === null ? null : parseFloat(props.values.total_mortgage_amount.replace(/[$,]/g, '')),
                home_value: props.values.home_worth === null ? null : parseFloat(props.values.home_worth.replace(/[$,]/g, '')),
            },
            new_home_purchase_price: props.values.new_home_purchase_price === null ? null : parseFloat(props.values.new_home_purchase_price.replace(/[$,]/g, '')),
            is_equity_required: props.values.is_equity_required === "true" ? true : false,
            equity_unlock_requested: props.values.equity_unlock_requested === null ? null : parseFloat(props.values.equity_unlock_requested.replace(/[$,]/g, '')),
            fees_are_for: props.values.other_fees_comment === null ? null : props.values.other_fees_comment,
            monthly_dues: props.values.fees_amount === null ? null : parseFloat(props.values.fees_amount.replace(/[$,]/g, '')),
            partner: props.partner && props.partner.partner_id ? props.partner.partner_id : null,
            is_loan_officer: props.values.is_loan_officer === "" ? false : (props.values.is_loan_officer === "true" ? true : false),
            loan_officer_info: {
                first_name: props.values.loan_officer_info.first_name,
                last_name: props.values.loan_officer_info.last_name,
                email: props.values.loan_officer_info.email === undefined ? '' : props.values.loan_officer_info.email,
                phone_number: (props.values.loan_officer_info.phone_number === "" || props.values.loan_officer_info.phone_number === null || props.values.loan_officer_info.phone_number === undefined) ? null : props.values.loan_officer_info.phone_number
            },
            is_real_estate_agent: props.values.is_real_estate_agent === '' ? false : (props.values.is_real_estate_agent === "true" ? true : false),
            real_estate_agent_info: {
                first_name: props.values.real_estate_agent_info.first_name,
                last_name: props.values.real_estate_agent_info.last_name,
                email: props.values.real_estate_agent_info.email === undefined ? '' : props.values.real_estate_agent_info.email,
                phone_number: (props.values.real_estate_agent_info.phone_number === undefined || props.values.real_estate_agent_info.phone_number === "" || props.values.real_estate_agent_info.phone_number === null) ? null : props.values.real_estate_agent_info.phone_number
            },
            hear_about_us_option_id: props.values.hear_about_us_option_id === null ? null : parseInt(props.values.hear_about_us_option_id),
            how_did_you_hear_about_us_description: props.values.how_did_you_hear_about_us_description === "" ? "" : props.values.how_did_you_hear_about_us_description
        }
        props.setLoaderNext(true)
        fetch(`${config.baseUrlCP}property/`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `${authorise}`,
                    'Content-Type': 'application/json',
                    'Accept-Encoding': 'gzip, deflate',
                },
                body: JSON.stringify(postData),
            })
            .then(async response => {
                const results = await response.json()
                if (response.status === 201 || response.status === 200) {
                    props.GAtimer()
                    GAEventTracker("UserAnsweredTillEligibility", 1)
                    setSubmitResponse(results);
                    props.setSubmitResponse(results);
                    gtag_report_conversion("UserAnsweredTillEligibility");
                    if (window.fcpixel) {
                        window.fcpixel.pxl(26594, results.application_number, "CALQUEPPG", results.application_number, 0, 0, "", "calquefc")
                    }
                    if (props.facebook_pixel === "facebook") {
                        window.fbq('track', 'Lead', { content_name: "CALQUEPPG", value: results.application_number });
                    }
                    sessionStorage.setItem('property_type_id', results.property_type_id)
                    sessionStorage.setItem('address', results.property_address.street_address)
                    setDetail(results.message);
                    props.setSubmitResponse(results);
                    props.setPropertyID(results.property_id)
                    props.values.property_id = results.property_id
                    props.setCaptchaValue(true)
                    props.setLoaderNext(false)
                    props.setGaUserNotAnswered(true)
                    props.setShowNxtButton(true)
                    if (submitValue === true) {
                        props.setCaptchaVisible(false)
                    }
                    props.handlePageChange(2)
                    props.setEmailOneDisable(true)
                    // let ele = document.getElementById("eligibility_complition")
                    // ele.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest", })
                    handleLeadActivitySubmit()
                }
                else {
                    if (results.detail) {
                        props.setGaUserNotAnswered(false)
                        setDetail(results.detail)
                        setOpenFailure(!openFailure);
                        props.setLoaderNext(false)
                    }
                    else {
                        props.setGaUserNotAnswered(false)
                        setDetail("something went wrong")
                        props.setLoaderNext(false)
                    }
                }
            })
            .catch((error) => {
                props.setGaUserNotAnswered(false)
                console.error('error message', error)
            })
    }

    const handleLeadActivitySubmit = () => {
        if (props.lead_activity_id !== null) {
            let authorise = process.env.REACT_APP_API_KEY;
            fetch(`${config.baseUrlCP}submitted-lead-source-track/`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `${authorise}`,
                    'Content-Type': 'application/json',
                    'Accept-Encoding': 'gzip, deflate',
                },
                body: JSON.stringify({
                    third_party_lead_source_id: props.lead_activity_id,
                    property_id: props.values.property_id
                }),
            })
                .then(async response => {
                    const results = await response.json()
                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }
    const handleInputValue = (eve) => {
        sessionStorage.setItem('captcha_val', eve)
        setResetInputValidation(false)
        setCaptchaEnteredValue(eve)
        if (eve.length === 5) {
            if (eve === captchaFreshValue) {
                props.setCaptchaValue(true)
                props.setErrorMessage(true)
            } else {
                props.setErrorMessage(false)
                props.setCaptchaValue(false)
            }
        } else {
            props.setErrorMessage(false)
            props.setCaptchaValue(null)
        }
    }

    const handleChange = (value) => {
        setCaptchaFreshValue(value);
        sessionStorage.setItem('captchaFreshValue', value)
    };

    useEffect(() => {
        generateCaptcha()
    }, [])

    useEffect(() => {
        let value = props && props.aboutUsList.filter(a => (a.hear_about_us_option_name == "Other" || a.hear_about_us_option_name == "Friend/Referral" || a.hear_about_us_option_name == "Social Media") && a.hear_about_us_option_id == props.values.hear_about_us_option_id)
        setDisplayTextBox(value)

        if (props.values.hear_about_us_option_id) {
            props.values.how_did_you_hear_about_us_description = ''
        }
    }, [props.values.hear_about_us_option_id])

    function generateCaptcha() {
        if(props.submitResponse === null){
            captchaRef.current.refresh();
        }
    }

    function handleRefreshCaptcha() {
        setResetInputValidation(true)
    }

    function StyledRadio(props) {
        const useStyles = makeStyles({
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            }
        })
        const classes = useStyles();

        return (
            <Radio
                className={classes.root}
                disableripple="true"
                color="default"
                checkedIcon={<CheckCircleIcon className="checkedIcon" />}
                icon={<RadioButtonUncheckedIcon />}
                {...props}
            />
        );
    }
    function Sendfailure() {
        const [open, setOpen] = React.useState(true);
        return (
            <>
                <div className="container-fluid m-0 top-padding-small bottom-padding-main px-md-5">
                    <div className="row px-md-5">
                        <div className="col-12 px-md-5">
                            <div className="justify-content-md-between align-items-md-center">
                                <h4 className="headerfont text-danger">Sorry for the Inconvenience ! Unfortunately your Data is Not Saved, Please fill it Again</h4>
                            </div>
                        </div>
                    </div>
                    <div className="row px-md-5">
                        <div className="col-12 px-md-5 pt-5">
                            <div className="d-flex justify-content-center">
                                <Button
                                    variant="contained" disableelevation="true"
                                    color="primary"
                                    type="submitt"
                                    className="jost-bold"
                                    style={{ height: '38px', width: '94px', color: 'white', backgroundColor: '#2661AB' }}
                                    {...{
                                        "aria-haspopup": "true",
                                        onClick: handlePopUpClose1,
                                    }}
                                >
                                    OK
                                </Button>

                            </div>

                        </div>
                    </div>
                </div>
            </>
        );
    }
   
    return (
        <div>
            <div className="form-question">
                <div className="form-content">
                    <h4 className="form-content-heading m-0">
                        How did you hear about us?
                    </h4>
                    <div className="check-box form-content-field">
                        <div className="py-2">
                            <div className='pt-2'>
                                <RadioGroup name="hear_about_us_option_id" value={props.values.hear_about_us_option_id} onChange={props.handleChange}>
                                    {props.aboutUsList && props.aboutUsList.map((about, index) => {
                                        return (
                                            <div key={index}>
                                                <FormControlLabel
                                                    key={about.hear_about_us_option_id}
                                                    label={about.hear_about_us_option_name}
                                                    control={<StyledRadio />}
                                                    value={about.hear_about_us_option_id.toString()}
                                                />
                                                {
                                                    displayTextBox[0] && displayTextBox[0].hear_about_us_option_name == "Other" ?
                                                        <div className='px-4'>
                                                            <TextField
                                                                type="text"
                                                                variant="outlined"
                                                                name="how_did_you_hear_about_us_description"
                                                                onBlur={props.handleChange}
                                                                value={props.values.how_did_you_hear_about_us_description.trimStart()}
                                                                onChange={props.handleChange}
                                                                className={(about.hear_about_us_option_name == "Other") ? 'd-block' : 'd-none'}
                                                            />
                                                        </div>
                                                        : ''
                                                }
                                                {
                                                    displayTextBox[0] && displayTextBox[0].hear_about_us_option_name == "Friend/Referral" ?
                                                        <div className='px-4'>
                                                            <TextField
                                                                type="text"
                                                                variant="outlined"
                                                                name="how_did_you_hear_about_us_description"
                                                                onBlur={props.handleChange}
                                                                value={props.values.how_did_you_hear_about_us_description}
                                                                onChange={props.handleChange}
                                                                className={(about.hear_about_us_option_name == "Friend/Referral") ? 'd-block' : 'd-none'}
                                                            />
                                                        </div>
                                                        : ''
                                                }
                                                {
                                                    displayTextBox[0] && displayTextBox[0].hear_about_us_option_name == "Social Media" ?
                                                        <div className='px-4'>
                                                            <TextField
                                                                type="text"
                                                                variant="outlined"
                                                                name="how_did_you_hear_about_us_description"
                                                                onBlur={props.handleChange}
                                                                value={props.values.how_did_you_hear_about_us_description.trimStart()}
                                                                onChange={props.handleChange}
                                                                className={(about.hear_about_us_option_name == "Social Media") ? 'd-block' : 'd-none'}
                                                            />
                                                        </div>
                                                        : ''
                                                }
                                            </div>
                                        )
                                    })}

                                </RadioGroup>
                            </div>

                            {props.validateDisplay8 === true ? props.errors.hear_about_us_option_id ?
                                <div className="error-msg">{props.errors.hear_about_us_option_id}</div> : ''
                                : ''}
                            {/* {props.captch_visible === true ?
                                <>
                                    <div className="d-sm-none d-none d-md-block d-lg-block pt-3">
                                        <ReCAPTCHA
                                            sitekey="6LekuFQeAAAAADY8Ot_1WhJtCvKGVIikI3_yPh93"
                                            onChange={onChange}
                                            id="recaptcha"
                                        />
                                    </div>
                                    <div style={{ transform: "scale(0.9)", transformOrigin: "0 0" }}
                                        className="d-lg-none d-md-none d-sm-block d-block w-100 position-relative pt-3">
                                        <ReCAPTCHA
                                            sitekey="6LekuFQeAAAAADY8Ot_1WhJtCvKGVIikI3_yPh93"
                                            onChange={onChange}
                                            id="recaptcha2"
                                            size="normal"
                                        />
                                    </div>
                                </>
                                : ''}
                            {
                                (props.errorMessage === true && props.captch_visible === true && submitValue === false) ?
                                    <p className="text-danger">
                                        Captcha verification failed
                                    </p>
                                    : ''
                            } */}
                            {/*{(props.propertyID || props.values.property_id) === null ?
                                <div className="pt-2 row" style={{ paddingBottom: '14vh' }}>
                                    <div className="py-2 col-md-auto">
                                        <Button className="form-button-primary" disabled={props.loaderNext === true} onClick={((props.propertyID || props.values.property_id) !== null && props.captch_visible === false) ? (e) => props.handleNext("howdidyouhear") : ((props.propertyID || props.values.property_id) === null && props.captch_visible === true && props.values.other_fees !== '' && props.errors.first_name != "" && props.errors.last_name != "" && props.errors.email != "" && props.errorMessage === false && Object.keys(props?.errors).length === 0 ? (e) => { handleSubmit(); props.ValidateFinalError() } : handleBefour)}>
                                            {props.loaderNext === false ? 'Submit' : <CircularProgress size={24} color="white" />}
                                        </Button>
                                    </div>
                                </div>
                                : ''} */}

                            {(props.submitResponse === null && (sessionStorage.getItem('property_type_id') !== props.values.property_type_id || sessionStorage.getItem('address') !== props.values.property_address.street_address.split(",")[0])) ?
                                <div className='captcha_parent'>
                                    <div className='captcha_sub_parent'>
                                        <div class="captcha_output">
                                            <CaptchaCode charNum="5" ref={captchaRef} onChange={handleChange} bgColor='#fff' className="captcha_code" />
                                        </div>
                                        <div class="captcha_gen">
                                            <img src="../../assets/images/restart.png" id="refresh" onClick={() => { generateCaptcha(); handleRefreshCaptcha() }} />
                                        </div>
                                    </div>
                                    <div class="captcha_bottom_container">
                                        <input type="text" id="captcha_input" onChangeCapture={props.handleChange} onChange={(e) => handleInputValue(e.target.value)} maxLength={5} placeholder="Enter captcha" /><label id="captcha_label">Captcha</label>
                                        {(props.validateDisplay10 === true && resetInputValidation === false) || (captchaEnteredValue && captchaEnteredValue.length === 5 && resetInputValidation === false) ?
                                            props.captchaValue === true ?
                                                <div style={{ color: 'green', fontSize: '12px' }}>Captcha is valid</div>
                                                : props.captchaValue === false ?
                                                    <div style={{ color: 'red', fontSize: '12px' }}>Captcha is invalid</div>
                                                    :
                                                    null
                                            :
                                            captchaEnteredValue && captchaEnteredValue.length === 5 && captchaEnteredValue !== captchaFreshValue ? <div style={{ color: 'red', fontSize: '12px' }}>Captcha is invalid</div> : null
                                        }
                                    </div>
                                </div>
                                : ''}
                            {(props.submitResponse === null && (sessionStorage.getItem('property_type_id') !== props.values.property_type_id || sessionStorage.getItem('address') !== props.values.property_address.street_address.split(",")[0])) &&
                                <p className='pt-3' style={{ fontSize: '1rem' }}>
                                    By clicking submit, I authorize Calque Inc. to share information with real estate agents and Lenders associated with my transaction.
                                </p>
                            }
                            {/* {(props.propertyID || props.values.property_id) === null ? */}
                                <div className="pt-2 row" style={{ paddingBottom: '14vh' }}>
                                    <div className="py-2 col-md-auto">
                                        {(props.propertyID || props.values.property_id) === null &&
                                        <Button className="form-button-primary" disabled={props.loaderNext === true} onClick={((props.propertyID || props.values.property_id) !== null) ? (e) => props.handleNext("howdidyouhear") : ((props.propertyID || props.values.property_id) === null && props.values.other_fees !== '' && props.errors.first_name != "" && props.errors.last_name != "" && props.errors.email != "" && Object.keys(props?.errors).length === 0 && sessionStorage.getItem('captcha_val') === captchaFreshValue ? (e) => { handleSubmit(); props.ValidateFinalError() } : handleBefour)}>
                                            {props.loaderNext === false ? 'Submit' : <CircularProgress size={24} color="white" />}
                                        </Button>}
                                        {(props.submitResponse !== null && props.showNxtButton === true) ?
                                        <Button className="form-button-primary" onClick={handleHomeSection}>
                                            Next
                                        </Button>
                                        :<></>
                                         } 
                                    </div>
                                </div>
                                {/* : ''} */}
                            {/* {(props.propertyID || props.values.property_id) !== null ?
                                <div id="eligibility_complition">
                                    <div className="py-2 row">
                                        <div className="py-2 col-md-auto">
                                            <div style={{ fontSize: '1rem' }}>
                                                The basic eligibility questions have been completed, but we’re not quite finished yet. To help us gather some additional home facts, please answer a few more questions <span className="text-blue" style={{ fontWeight: 'bolder', cursor: 'pointer', textDecoration: 'underline' }} onClick={(e) => props.handleNext("howdidyouhear")}>below</span>.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : ''} */}
                        </div>
                    </div>
                </div>
                <Modalpopup open={openFailure} handleClickOpen={handleCloseFailure} contact={Sendfailure()} />
            </div>
        </div>)
}